module.exports = __webpack_public_path__ + "static/img/title.74d8e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/floor5/title.png
// module id = sUiF
// module chunks = 2